import React from "react";
import Hero from "../../components/Hero";
import Card from "../../components/Card";

export default function index() {
  return (
    <div>
      <Hero />
      <Card />
    </div>
  );
}
